export default "__VITE_ASSET__Cp5w5WDr__"